import React from 'react';
import { Activity, ShieldCheck, Zap } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const MonitoringPage = () => {
  const config = {
    badge: "Patient Monitoring",
    headline: "Continuous Patient",
    headlineItalic: "Monitoring.",
    subtext: "Real-time, multi-parameter patient monitoring and comprehensive electronic medical records ensuring the highest level of care continuity and safety.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Patient Monitoring at Dr. Suresh Pet Care — Electronic Medical Records",
    stats: [
      { value: 10000, suffix: '+', label: 'Patient Records' },
      { value: 24, suffix: '/7', label: 'ICU Monitoring' },
      { value: 100, suffix: '%', label: 'Digital Records' },
      { value: 5, suffix: '+', label: 'Monitoring Parameters' },
    ],
    services: [
      {
        title: "Multi-Parameter Monitoring",
        icon: <Activity size={28} />,
        desc: "Continuous ECG, SpO2, blood pressure, temperature, and respiratory monitoring for hospitalized patients.",
        specs: ["Continuous ECG", "SpO2 Tracking", "Blood Pressure", "Temp Monitoring"],
        color: "from-blue-500/10 to-primary/10"
      },
      {
        title: "Electronic Medical Records",
        icon: <ShieldCheck size={28} />,
        desc: "Comprehensive digital patient records with full history, lab results, imaging, and prescription tracking.",
        specs: ["Full Clinical History", "Lab Integration", "Imaging Archive", "Prescription Records"],
        color: "from-primary/10 to-green-500/10"
      },
      {
        title: "Post-Op Surveillance",
        icon: <Zap size={28} />,
        desc: "Dedicated post-operative monitoring protocols ensuring safe anaesthesia recovery and early complication detection.",
        specs: ["Anaesthesia Recovery", "Pain Scoring", "Wound Assessment", "Recovery Milestones"],
        color: "from-teal-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Monitoring",
    sectionItalic: "Systems.",
    warningTitle: "Why Continuous",
    warningItalic: "Monitoring Matters.",
    warningText: "Veterinary emergencies can develop rapidly in hospitalized patients. Continuous monitoring enables immediate detection and intervention before conditions deteriorate.",
    warnings: [
      { name: "Anaesthesia Safety", desc: "Multi-parameter monitoring significantly reduces anaesthetic risk during procedures.", icon: "💤" },
      { name: "Post-Op Recovery", desc: "The first 24 hours post-surgery are critical — constant surveillance is essential.", icon: "⏱️" },
      { name: "ICU Patients", desc: "Critically ill patients require real-time monitoring that humans cannot provide alone.", icon: "🏥" },
      { name: "Arrhythmia Detection", desc: "Continuous ECG detects life-threatening cardiac arrhythmias early for intervention.", icon: "❤️" },
    ],
    ctaBadge: "Care Continuity",
    ctaTitle: "The Monitoring",
    ctaItalic: "Expertise.",
    ctaText: "Our monitoring technology and electronic medical records system ensures nothing is missed — delivering the highest level of patient safety and care continuity.",
    ctaBtn: "Learn About Our Care",
    seoText: "Advanced veterinary patient monitoring in Hyderabad. Electronic medical records and ICU monitoring at Dr. Suresh Pet Care. Continuous pet health surveillance.",
    glowColor: "blue-500"
  };

  return (
    <>
      <SEO 
        title="Electronic Medical Records & Patient Monitoring"
        description="Advanced patient monitoring and electronic medical records system at Dr. Suresh Pet Care, Hyderabad. Comprehensive, continuous health tracking."
        canonical="/monitoring"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default MonitoringPage;
